import { For, createSignal } from "solid-js";
import { Modal } from "~/ui/Modal";
import type { GoalCategory, GoalDraft } from "./goals";

export function AddGoalModal(props: {
  categories: GoalCategory[];
  busy: boolean;
  onClose: () => void;
  onSave: (draft: GoalDraft) => Promise<void>;
}) {
  const [title, setTitle] = createSignal("");
  const [description, setDescription] = createSignal("");
  const [categoryId, setCategoryId] = createSignal("");

  return <Modal title="Neues Ziel hinzufügen" onClose={props.onClose}>
    <form onSubmit={(event) => { event.preventDefault(); void props.onSave({ title: title(), description: description(), categoryId: categoryId() || null }); }}>
      <div class="form-group">
        <label class="form-label" for="new-goal-title">Titel *</label>
        <input id="new-goal-title" class="form-input" placeholder="z.B. Wir hören einander zu" value={title()} onInput={(event) => setTitle(event.currentTarget.value)} />
      </div>
      <div class="form-group">
        <label class="form-label" for="new-goal-desc">Beschreibung</label>
        <textarea id="new-goal-desc" class="form-textarea" placeholder="Was bedeutet dieses Ziel konkret?" value={description()} onInput={(event) => setDescription(event.currentTarget.value)} />
      </div>
      <div class="form-group">
        <label class="form-label" for="new-goal-cat">Kategorie</label>
        <select id="new-goal-cat" class="form-select" value={categoryId()} onChange={(event) => setCategoryId(event.currentTarget.value)}>
          <option value="">Keine Kategorie</option>
          <For each={props.categories}>{(category) => <option value={category.id}>{category.icon || ""} {category.name}</option>}</For>
        </select>
      </div>
      <button class="btn btn-primary btn-full" type="submit" disabled={props.busy}>Ziel hinzufügen</button>
    </form>
  </Modal>;
}
